module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (5).412d4c8a.svg";